import { getAPICallServer } from '../utils/axios.util'
import { apiServerRoutes } from '../constants/apiRoutes'
class generalService {
  async listAllManufacturer(req: any) {
    return getAPICallServer(apiServerRoutes.MANUFACTURER, req)
  }

  async listAllManufacturerModals(req: any) {
    return getAPICallServer(
      apiServerRoutes.MANUFACTURER_MODELS.replace(':id', req.body.id),
      req,
    )
  }

  async listAllAttachments(req: any) {
    return getAPICallServer(apiServerRoutes.ATTACHMENTS, req)
  }
}

export default new generalService()
